import { Button } from 'react-bootstrap';
import React from 'react'

const Connect = () => {
    return (
        <div className='connect'>
            <div className='max-width cCont'>
                <div className='cMhead'>
                    Let’s connect
                </div>
                <div className='cp'>
                    Udeline provides a special feature where you can connect with people from your dream college.
                    Get a completely genuine review of your college.
                </div>
                <div className='cbtn'>
                    <Button>Let’s Try Basic counselling Session</Button>
                </div>
                <div className='cImg'>
                    <img src='connectimg.png' alt='' />
                </div>
            </div>
        </div>
    )
}

export default Connect;